/**
 * Upper-case the first UTF-16 code unit of `value`, leaving the rest as-is
 * (`'growth'` → `'Growth'`, `'ALL'` → `'ALL'`, `''` → `''`). Not a title-caser
 * and not locale-aware — the same one-liner every copy spelled.
 *
 * Leaf module: zero imports, no `server-only` — safe from client components,
 * scripts, workflows, and `convex/`.
 *
 * Canonical for the 2026-09 phase-4 debt sweep's `capitalize` family: the
 * three module-private copies (`lib/brand/primitives/style-profile/format.ts`,
 * `lib/agents/prompts/background-image-prompt.ts`, `lib/mcp/present.ts`) and
 * the inline `word.charAt(0).toUpperCase() + word.slice(1)` word-capitalizers
 * in the title-casing pipelines were all this expression — the `if (!s)` and
 * `s.length ?` guards the copies carried change nothing for the empty string
 * (`''.charAt(0)` and `''.slice(1)` are both `''`), so the bodies are
 * semantically identical (tests/shared/capitalize.test.ts pins it). Written as
 * a template literal so the leaf itself does not spell the `+` shape the
 * no-shared-leaf-copies guard bans.
 */
export function capitalize(value: string): string {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
}
